import { dashboardTour } from './dashboardTour'
import { apiKeysTour } from './apiKeysTour'
import { modelsTour } from './modelsTour'
import { analyticsTour } from './analyticsTour'
import { billingTour } from './billingTour'
import { agentsTour } from './agentsTour'
import { agentBuilderTour } from './agentBuilderTour'
import type { TourDefinition } from '../types'

const tours: Record<string, TourDefinition> = {
  'dashboard-welcome': { steps: dashboardTour },
  'api-keys-guide': { steps: apiKeysTour },
  'models-routing-guide': { steps: modelsTour },
  'analytics-guide': { steps: analyticsTour },
  'billing-guide': { steps: billingTour },
  'agents-guide': { steps: agentsTour },
  'agents-builder-guide': { steps: agentBuilderTour },
}

export function getTourDefinition(tourId: string): TourDefinition | null {
  return tours[tourId] || null
}

export const TOUR_IDS = {
  DASHBOARD: 'dashboard-welcome',
  API_KEYS: 'api-keys-guide',
  MODELS: 'models-routing-guide',
  ANALYTICS: 'analytics-guide',
  BILLING: 'billing-guide',
  AGENTS: 'agents-guide',
  AGENTS_BUILDER: 'agents-builder-guide',
} as const
